import React from 'react';
import Breadcrumbs from '@/widgets/breadcrumbs';
import ReviewSubmitSolicitation from './review-submit-solicitation';
import ReviewSubmitProvider from './review-submit-provider';
import { breadcrumbsPath } from '../../utils/solicitation-helpers';

const ReviewSolicitation = () => {
  return (
    <div className="grid-col">
      <Breadcrumbs current="Edit Solicitation" path={breadcrumbsPath} />
      <ReviewSubmitProvider>
        <ReviewSubmitSolicitation />
      </ReviewSubmitProvider>
    </div>
  );
};

export default ReviewSolicitation;
